import { Injectable } from "@angular/core";
import { Headers, Http } from '@angular/http';
import { Storage } from '@ionic/storage';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { RequestRefreshTokenDto } from "../../shared/nestjs/gd-only/dto/auth.dto";
import { AuthApi } from "../../shared/nestjs/gd-only/services/auth.api";
import { NestApiProvider } from "../../shared/nestjs/nest-api";
import { NestAuthProvider } from "../../shared/nestjs/nest-auth";
import { LoopBackAuth, LoopBackConfig } from "../../shared/sdk";
import { StoredPrelogin } from './../../model/gd-storage';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthenticationBloc } from "../../bloc/authentication/authentication.bloc";

@Injectable()
export class SaasProvider {


  private stotredPrelogin: StoredPrelogin;

  constructor(
    public auth: LoopBackAuth,
    public storage: Storage,
    public httpClient: HttpClient,
    public http: Http,
    public nestAuth: NestAuthProvider,
    public nestApi: NestApiProvider,
    public authNestApi: AuthApi,
    private authenticationBloc: AuthenticationBloc
  ) {

  }

  getUpdateAuth(refresh: boolean = false): Promise<{ forceLogout: boolean }> {
    return new Promise(async (resolve) => {
      const result = {
        forceLogout: false
      };

      try {
        await this.storage.ready();
        const storage = JSON.parse(await this.storage.get('SFGoStorage'));
        const auth = JSON.parse(await this.storage.get('SFGoAuth'));
        const account = { 'account': storage.storedPrelogin.IST }
        const headers = new HttpHeaders();
        const urlSaas = 'https://saas.dataon.com/sf6svc/SFCSunFish.cfm?PROVIDER=GetAPIConfig&STRAUTHKEY=9C1C5414B09EE2C0A7925C3FCC7CD25DBF54ECEDBB90BBFDA5C84F1F4CC660B95B6B3AFF2DFB05CC577B12A2ECD8072099BFF8D0CC7A0CAB3B985735&parameter=';
        headers.append('Content-Type', 'application/x-www-form-urlencoded');

        this.httpClient.get<ResponseSaasDto>(urlSaas + JSON.stringify(account), { headers: headers })
          .timeout(30000)
          .subscribe(
            async (response) => {
              try {
                if (response.RESULT === true) {
                  const preloginData = response.DATA;
                  auth.path = response.DATA.GOPATH;

                  if (storage.storedPrelogin.IST.indexOf('-gd') >= 0) {
                    var splitTmp = storage.storedPrelogin.IST.split('-');
                    splitTmp.forEach(element => {
                      if (element.indexOf('gd') >= 0) {
                        var splitTmp2 = element.split('|');
                        if (splitTmp2.length > 1) {
                          response.DATA.GOPATHNEW = splitTmp2[1];
                        }
                      }
                    });
                  }

                  let SFGoStoragex = await this.storage.get('SFGoStorage');
                  try {
                    let SFGoStorage = JSON.parse(SFGoStoragex);
                    if (SFGoStorage == null) {
                      SFGoStorage = {}
                    }

                    SFGoStorage.storedPrelogin = response.DATA;
                    this.stotredPrelogin = SFGoStorage.storedPrelogin;

                    if (this.stotredPrelogin.hasOwnProperty('GOPATHNEW')) {
                      const gopathNew = this.stotredPrelogin.GOPATHNEW;
                      /** Hapus gopath new jika gopath new string kosong, null, atau undefined */
                      if (!gopathNew) {
                        delete this.stotredPrelogin.GOPATHNEW;
                        SFGoStorage.storedPrelogin = this.stotredPrelogin;
                      }
                    }

                    this.storage.set('SFGoStorage', JSON.stringify(SFGoStorage));
                  } catch (error) {

                  }

                  if (preloginData.hasOwnProperty('GOPATHNEW')) {
                    let refreshData = { forceLogout: null }
                    if (refresh) {
                      refreshData = await this.getRefreshData(preloginData, auth.id, auth.refreshToken);
                    } else {
                      refreshData = await this.getLoginData(preloginData, auth.id);
                    }

                    result.forceLogout = refreshData.forceLogout;
                  } else {
                    LoopBackConfig.setBaseURL(auth.path);
                    this.storage.set('SFGoAuth', JSON.stringify(auth));
                  }

                }
                resolve(result);
              } catch (err) {
                resolve(result);
              }
            },
            error => {
              resolve(result);
            }
          );
      } catch (error) {
        resolve(result);
      }
    })
  }

  getLoginData(preloginData, token: string): Promise<{ forceLogout: boolean }> {
    return new Promise((resolve) => {
      const result = {
        forceLogout: false
      }

      this.nestAuth.loginData(preloginData.GOPATHNEW, token)
        .subscribe((response) => {
          response.path = preloginData.GOPATH;
          response.saasData = preloginData;

          if (!response['multiCompany'].company_list) {
            response['multiCompany']['company_list'] = JSON.parse(JSON.stringify(response['multiCompany']['companyList']));
            response['multiCompany']['main_company'] = JSON.parse(JSON.stringify(response['multiCompany']['mainCompany']));
            response['multiCompany']['main_company_code'] = JSON.parse(JSON.stringify(response['multiCompany']['mainCompanyCode']));
            let i = 0;
            for (let item of response['multiCompany']['company_list']) {
              response['multiCompany']['company_list'][i]['company_code'] = item.companyCode;
              response['multiCompany']['company_list'][i]['company_id'] = item.companyId;
              response['multiCompany']['company_list'][i]['company_name'] = item.companyName;
              i++;
            }
          }

          LoopBackConfig.setBaseURL(response.path);
          this.storage.set('SFGoAuth', JSON.stringify(response));
          this.nestApi.setHost();

          resolve(result)
        }, error => {
          resolve(result)
        })
    })
  }

  getRefreshData(preloginData, token: string, refreshToken: string): Promise<{ forceLogout: boolean }> {
    return new Promise((resolve) => {
      let body: RequestRefreshTokenDto = {
        refreshToken: refreshToken,
        accessToken: token
      }

      let result = {
        forceLogout: false
      }

      this.authNestApi.refreshToken(body)
        .subscribe((response) => {
          response.path = preloginData.GOPATH;
          response.saasData = preloginData;

          if (!response['multiCompany'].company_list) {
            response['multiCompany']['company_list'] = JSON.parse(JSON.stringify(response['multiCompany']['companyList']));
            response['multiCompany']['main_company'] = JSON.parse(JSON.stringify(response['multiCompany']['mainCompany']));
            response['multiCompany']['main_company_code'] = JSON.parse(JSON.stringify(response['multiCompany']['mainCompanyCode']));
            let i = 0;
            for (let item of response['multiCompany']['company_list']) {
              response['multiCompany']['company_list'][i]['company_code'] = item.companyCode;
              response['multiCompany']['company_list'][i]['company_id'] = item.companyId;
              response['multiCompany']['company_list'][i]['company_name'] = item.companyName;
              i++;
            }
          }

          LoopBackConfig.setBaseURL(response.path);

          response.ttl = parseInt(response.ttl, 0);
          response.rememberMe = true;
          response.user = JSON.stringify(response);

          // set token
          this.auth.setToken(response);
          this.storage.set('SFGoAuth', JSON.stringify(response));
          this.nestApi.setHost();

          resolve(result);
        }, error => {
          result.forceLogout = true;
          resolve(result);
        })
    })
  }

  callSaasAPI(companyCode: String): Observable<any> {
    return Observable.create((observer) => {
      const headers = new Headers();
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      let url: string = 'https://saas.dataon.com/sf6svc/SFCSunFish.cfm?PROVIDER=GetAPIConfig&STRAUTHKEY=9C1C5414B09EE2C0A7925C3FCC7CD25DBF54ECEDBB90BBFDA5C84F1F4CC660B95B6B3AFF2DFB05CC577B12A2ECD8072099BFF8D0CC7A0CAB3B985735&';
      let url2: string = 'https://sf.dataon.com/sf6/noapp/getapiconfig.cfm?account=' + companyCode;
      let url3: string = 'https://sfasia.dataon.com/sf6/noapp/getapiconfig.cfm?account=' + companyCode;

      this.http.post(
        url,
        'parameter=' + JSON.stringify({ 'account': companyCode }),
        { headers: headers })
        .timeout(30000)
        .subscribe(res => {
          observer.next(res)
          observer.complete()
        }, err => {
          this.http.post(
            url2,
            "",
            { headers: headers })
            .timeout(30000)
            .subscribe(res => {
              observer.next(res)
              observer.complete()
            }, err => {
              this.http.post(
                url3,
                "",
                { headers: headers })
                .timeout(30000)
                .subscribe(res => {
                  observer.next(res)
                  observer.complete()
                }, err => {
                  observer.error(err)
                })
            })
        })
    })
  }

  loadSaas(companyCode): Promise<ResponseSaasDto> {
    return new Promise((resolve, reject) => {
      companyCode = this.authenticationBloc.convertIST(companyCode);
      console.log('ist code',companyCode)
      const account = { 'account': companyCode };
      const urlSaas = 'https://saas.dataon.com/sf6svc/SFCSunFish.cfm?PROVIDER=GetAPIConfig&STRAUTHKEY=9C1C5414B09EE2C0A7925C3FCC7CD25DBF54ECEDBB90BBFDA5C84F1F4CC660B95B6B3AFF2DFB05CC577B12A2ECD8072099BFF8D0CC7A0CAB3B985735&parameter=';
      
      this.httpClient.get<ResponseSaasDto>(urlSaas + JSON.stringify(account))
        .timeout(10000)
        .subscribe((response) => {
          try {
            if (typeof (response.RESULT) != 'undefined' && response.RESULT != null) {
              const preloginData = response.DATA;
              LoopBackConfig.setBaseURL(preloginData.GOPATH);
              console.log('success set base url')
              if (preloginData.hasOwnProperty('GOPATHNEW')) {
                const gopathNew = preloginData.GOPATHNEW;
                if (gopathNew) {
                  this.nestApi.setBaseURL(gopathNew);
                  console.log('success set base url nest api')
                }
              }
            }

            console.log('result saas res',response);
          } catch (err) {
            console.log('load saas error', err);
          }

          resolve(response)
        }, error => {
          reject(error)
        })
    })
  }
}


export interface DATA {
  SFPATH: string;
  MODE: string[];
  ACCOUNT: string;
  IST: string;
  CUSTOM: any[];
  ACCOUNTNAME: string;
  GOPATHNEW: string;
  GOPATH: string;
}

export interface ResponseSaasDto {
  DATA: DATA;
  ERRMSG: string;
  RESULT: boolean;
}



// WEBPACK FOOTER //
// ./src/providers/saas/saas.ts